import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledTitle = styled.div`
    font-size: var(--size-16);
    font-weight: var(--weight-600);
    color: var(--color-primary);
    text-transform: uppercase;
    margin-bottom: 10px;

    @media ${breakpoints.xs} {
        font-size: var(--size-14);
    }
`;
